import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppModeSwitcher from './AppModeSwitcher';
import reportWebVitals from './reportWebVitals';
import { initErrorTracking } from './errorTracking';

initErrorTracking(); // does nothing unless REACT_APP_SENTRY_DSN is set

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppModeSwitcher />
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Version the worker by this build's bundle hashes, so each deploy gets a fresh
    // cache and the old ones are dropped (see public/sw.js).
    const version = [...document.querySelectorAll('script[src*="/static/js/main."], link[href*="/static/css/main."]')]
      .map((el) => (el.src || el.href).match(/main\.([0-9a-f]+)\./)?.[1])
      .filter(Boolean)
      .join('-') || 'dev';
    navigator.serviceWorker.register(`/sw.js?v=${version}`).catch(() => {});
  });
}

reportWebVitals();